export default {"src":"/_next/static/media/new-request.38988c83.svg","height":14,"width":14};